import { convertDisplayToOptions } from "./convertDisplayToOptions";

export const getCurrentDisplayValue = ({
  value,
  options,
}: {
  value: string;
  options: ReturnType<typeof convertDisplayToOptions>;
}) => {
  return options.find((option) => option.value === value);
};
